// import React, { useMemo, useState } from "react";
// import { Mail, Loader2 } from "lucide-react";
// import { useLocation } from "react-router-dom";
// import Checkbox from "../../Checkbox";
// import api from "../chat/api";
// import { toast } from "react-toastify";

// const InvitationsPage = ({ 
//   invitations, 
//   loading, 
//   searchQuery, 
//   organizationId, 
//   onRefresh,
//   selectedInvitations,
//   setSelectedInvitations 
// }) => {
//   const [resendingIds, setResendingIds] = useState([]);
//   const [resentIds, setResentIds] = useState([]);
//   const [cancelingIds, setCancelingIds] = useState([]);
//   const [canceledIds, setCanceledIds] = useState([]);

//   const location = useLocation();

//   const organizationIdFromUrl = useMemo(() => {
//     const segments = location.pathname.split("/").filter(Boolean);
//     const last = segments[segments.length - 1];
//     const asNumber = Number(last);
//     return Number.isFinite(asNumber) && last !== "" ? asNumber : last;
//   }, [location.pathname]);

//   const resolvedOrganizationId = organizationId ?? organizationIdFromUrl;

//   const filteredInvitations = useMemo(() => {
//     if (!searchQuery.trim()) return invitations;
//     const query = searchQuery.toLowerCase().trim();
//     return invitations.filter(inv => inv.email.toLowerCase().includes(query));
//   }, [invitations, searchQuery]);

//   const handleSelectAllChange = (checked) => {
//     if (checked) {
//       setSelectedInvitations(filteredInvitations.map(inv => inv.id));
//     } else {
//       setSelectedInvitations([]);
//     }
//   };

//   const handleInvitationSelect = (checked, id) => {
//     if (checked) {
//       setSelectedInvitations(prev => [...prev, id]);
//     } else {
//       setSelectedInvitations(prev => prev.filter(i => i !== id));
//     }
//   };

//   const handleResendInvitation = async (invitationId) => {
//     setResendingIds(prev => [...prev, invitationId]);
//     setResentIds(prev => prev.filter(id => id !== invitationId));

//     try {
//       const response = await api.post('/api/v1/org/invites/resend/', {
//         organization_id: resolvedOrganizationId,
//         invitation_ids: [invitationId]
//       });

//       const data = response.data || response;

//       if (data?.errors?.length > 0) {
//         const errorItem = data.errors.find(err => err.invitation_id === invitationId);
//         if (errorItem) {
//           toast.error(errorItem.error);
//           return;
//         }
//       }

//       setResentIds(prev => [...prev, invitationId]);
      
//       setTimeout(() => {
//         setResentIds(prev => prev.filter(id => id !== invitationId));
//         onRefresh();
//       }, 1500);

//     } catch (error) {
//       console.error("Error resending invitation:", error);
//       toast.error("Failed to resend invitation. Please try again.");
//     } finally {
//       setResendingIds(prev => prev.filter(id => id !== invitationId));
//     }
//   };

//   const handleCancelInvitation = async (invitationId) => {
//     setCancelingIds(prev => [...prev, invitationId]);
//     setCanceledIds(prev => prev.filter(id => id !== invitationId));

//     try {
//       await api.post('/api/v1/org/invites/cancel/', {
//         organization_id: resolvedOrganizationId,
//         invitation_ids: [invitationId]
//       });

//       setCanceledIds(prev => [...prev, invitationId]);
      
//       setTimeout(() => {
//         setCanceledIds(prev => prev.filter(id => id !== invitationId));
//         onRefresh();
//       }, 1500);
//     } catch (error) {
//       console.error("Error canceling invitation:", error);
//       toast.error("Failed to cancel invitation.");
//     } finally {
//       setCancelingIds(prev => prev.filter(id => id !== invitationId));
//     }
//   };

//   const getResendButtonContent = (invId) => {
//     if (resendingIds.includes(invId)) return <>Resending...</>;
//     if (resentIds.includes(invId)) return "Resent";
//     return "Resend";
//   };

//   const getCancelButtonContent = (invId) => {
//     if (cancelingIds.includes(invId)) return <>Canceling...</>;
//     if (canceledIds.includes(invId)) return "Canceled";
//     return "Cancel";
//   };

//   return (
//     // Changed: Using absolute inset-0 to perfectly fill the parent container
//     <div className="absolute inset-0 overflow-y-auto overflow-x-hidden custom-scrollbar bg-white">
//       {loading ? (
//         <div className="h-full w-full flex items-center justify-center">
//           <div className="flex flex-col items-center gap-3">
//             <Loader2 className="w-10 h-10 text-[#C95EBE] animate-spin" />
//             <p className="text-[14px] text-gray-500">Loading invitations...</p>
//           </div>
//         </div>
//       ) : filteredInvitations.length === 0 ? (
//         <div className="h-full w-full flex items-center justify-center">
//           <div className="text-center">
//             <Mail className="w-12 h-12 text-gray-300 mx-auto mb-3" />
//             <p className="text-[14px] text-gray-500">
//               {searchQuery ? "No invitations match your search" : "No invitations found"}
//             </p>
//           </div>
//         </div>
//       ) : (
//         <table className="w-full text-left border-collapse table-fixed">
//           <thead>
//             <tr className="border-b border-black/10 sticky top-0 z-20 bg-gray-50">
//               <th className="px-4 py-3 w-12 bg-gray-50">
//                 <Checkbox
//                   id="select-all-inv"
//                   checked={selectedInvitations.length === filteredInvitations.length && filteredInvitations.length > 0}
//                   onChange={handleSelectAllChange}
//                   size="sm"
//                 />
//               </th>
//               {/* Changed: Removed min-w and used percentages to allow fluid shrinking */}
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-2/5">
//                 Email Address
//               </th>
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[15%]">
//                 Role
//               </th>
//               <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[20%]">
//                 Invitation Sent
//               </th>
//               <th className="px-4 py-3 bg-gray-50"></th>
//             </tr>
//           </thead>
//           <tbody className="bg-white">
//   {filteredInvitations.map((inv) => (
//     <tr key={inv.id} className="hover:bg-gray-50 transition-colors">
//       <td className="px-4 py-3 w-12 border-b border-gray-100">
//         <Checkbox
//           id={`inv-${inv.id}`}
//           checked={selectedInvitations.includes(inv.id)}
//           onChange={(checked) => handleInvitationSelect(checked, inv.id)}
//           size="sm"
//         />
//       </td>
//       <td className="px-4 py-3 text-[14px] font-medium text-[#18101C] truncate border-b border-gray-100">
//         {inv.email}
//       </td>
//       <td className="px-4 py-3 border-b border-gray-100">
//         <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-md capitalize">
//           {inv.role}
//         </span>
//       </td>
//       <td className="px-4 py-3 text-[14px] text-gray-700 whitespace-nowrap border-b border-gray-100">
//         {inv.invitationSent}
//       </td>
//       <td className="px-4 py-3 text-right pr-6 border-b border-gray-100">
//         <div className="flex items-center gap-2 justify-end">
//           <button 
//             onClick={() => handleResendInvitation(inv.id)}
//             disabled={resendingIds.includes(inv.id) || resentIds.includes(inv.id)}
//             className={`flex items-center gap-1.5 px-4 py-1.5 rounded-md text-xs font-medium transition-colors ${
//               resentIds.includes(inv.id)
//                 ? 'bg-[#C95EBE] text-white cursor-default'
//                 : resendingIds.includes(inv.id)
//                 ? 'bg-[#B14DAA] text-white cursor-not-allowed opacity-80'
//                 : 'bg-[#C95EBE] text-white hover:bg-[#B14DAA]'
//             }`}
//           >
//             {getResendButtonContent(inv.id)}
//           </button>
//           <button 
//             onClick={() => handleCancelInvitation(inv.id)}
//             disabled={cancelingIds.includes(inv.id) || canceledIds.includes(inv.id)}
//             className={`px-4 py-1.5 border rounded-md text-xs font-medium transition-colors ${
//               canceledIds.includes(inv.id)
//                 ? 'border-red-500 bg-red-500 text-white cursor-default'
//                 : cancelingIds.includes(inv.id)
//                 ? 'border-red-500 bg-red-500 text-white cursor-not-allowed opacity-80'
//                 : 'border-red-500 text-red-500 hover:bg-red-500 hover:text-white'
//             }`}
//           >
//             {getCancelButtonContent(inv.id)}
//           </button>
//         </div>
//       </td>
//     </tr>
//   ))}
// </tbody>

//         </table>
//       )}
//     </div>
//   );
// };

// export default InvitationsPage;
import React, { useMemo, useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import Checkbox from "../../Checkbox";
import api from "../chat/api";
import toast from "react-hot-toast";

const InvitationsPage = ({
  invitations, 
  loading, 
  searchQuery, 
  organizationId, 
  onRefresh,
  selectedInvitations,
  setSelectedInvitations 
}) => {
  const [resendingIds, setResendingIds] = useState([]);
  const [resentIds, setResentIds] = useState([]);
  const [cancelingIds, setCancelingIds] = useState([]);
  const [canceledIds, setCanceledIds] = useState([]);

  // Org comes from MyTeam, which sources it from selected_org_id (in sync with the
  // global sidebar workspace switcher).
  const resolvedOrganizationId = organizationId;

  const filteredInvitations = useMemo(() => {
    if (!searchQuery.trim()) return invitations;
    const query = searchQuery.toLowerCase().trim();
    return invitations.filter(inv => inv.email.toLowerCase().includes(query));
  }, [invitations, searchQuery]);

  const handleSelectAllChange = (checked) => {
    if (checked) {
      setSelectedInvitations(filteredInvitations.map(inv => inv.id));
    } else {
      setSelectedInvitations([]);
    }
  };

  const handleInvitationSelect = (checked, id) => {
    if (checked) {
      setSelectedInvitations(prev => [...prev, id]);
    } else {
      setSelectedInvitations(prev => prev.filter(i => i !== id));
    }
  };

  const handleResendInvitation = async (invitationId) => {
    setResendingIds(prev => [...prev, invitationId]);
    setResentIds(prev => prev.filter(id => id !== invitationId));

    try {
      const response = await api.post('/api/v1/org/invites/resend/', {
        organization_id: resolvedOrganizationId,
        invitation_ids: [invitationId]
      });

      const data = response.data || response;

      if (data?.errors?.length > 0) {
        const errorItem = data.errors.find(err => err.invitation_id === invitationId);
        if (errorItem) {
          toast.error(errorItem.error);
          return;
        }
      }

      setResentIds(prev => [...prev, invitationId]);
      
      setTimeout(() => {
        setResentIds(prev => prev.filter(id => id !== invitationId));
        onRefresh();
      }, 1500);

    } catch (error) {
      console.error("Error resending invitation:", error);
      toast.error("Failed to resend invitation. Please try again.");
    } finally {
      setResendingIds(prev => prev.filter(id => id !== invitationId));
    }
  };

  const handleCancelInvitation = async (invitationId) => {
    setCancelingIds(prev => [...prev, invitationId]);
    setCanceledIds(prev => prev.filter(id => id !== invitationId));

    try {
      await api.post('/api/v1/org/invites/cancel/', {
        organization_id: resolvedOrganizationId,
        invitation_ids: [invitationId]
      });

      setCanceledIds(prev => [...prev, invitationId]);
      
      setTimeout(() => {
        setCanceledIds(prev => prev.filter(id => id !== invitationId));
        onRefresh();
      }, 1500);
    } catch (error) {
      console.error("Error canceling invitation:", error);
      toast.error("Failed to cancel invitation.");
    } finally {
      setCancelingIds(prev => prev.filter(id => id !== invitationId));
    }
  };

  const getResendButtonContent = (invId) => {
    if (resendingIds.includes(invId)) return <>Resending...</>;
    if (resentIds.includes(invId)) return "Resent";
    return "Resend";
  };

  const getCancelButtonContent = (invId) => {
    if (cancelingIds.includes(invId)) return <>Revoking...</>;
    if (canceledIds.includes(invId)) return "Revoked";
    return "Revoke";
  };

  return (
    <div className="absolute inset-0 overflow-y-auto overflow-x-hidden custom-scrollbar bg-white">
      {loading ? (
        <div className="h-full w-full flex items-center justify-center">
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="w-10 h-10 text-[#C95EBE] animate-spin" />
            <p className="text-[14px] text-gray-500">Loading invitations...</p>
          </div>
        </div>
      ) : filteredInvitations.length === 0 ? (
        <div className="h-full w-full flex items-center justify-center">
          <div className="text-center">
            <Mail className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-[14px] text-gray-500">
              {searchQuery ? "No invitations match your search" : "No invitations found"}
            </p>
          </div>
        </div>
      ) : (
        <table className="w-full text-left border-collapse table-fixed border-none border-l-0 border-r-0">
          <thead>
            <tr className="border-b border-black/10 border-l-0 border-r-0 border-t-0 sticky top-0 z-20 bg-gray-50">
              <th className="px-4 py-3 w-12 bg-gray-50 border-none border-l-0 border-r-0">
                <Checkbox
                  id="select-all-inv"
                  checked={selectedInvitations.length === filteredInvitations.length && filteredInvitations.length > 0}
                  onChange={handleSelectAllChange}
                  size="sm"
                />
              </th>
              <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[35%] border-none border-l-0 border-r-0">
                Email Address
              </th>
              <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[15%] border-none border-l-0 border-r-0">
                Role
              </th>
              <th className="px-4 py-3 text-[14px] font-semibold text-gray-600 bg-gray-50 w-[20%] border-none border-l-0 border-r-0">
                Invitation Sent
              </th>
              <th className="px-4 py-3 bg-gray-50 w-[25%] border-none border-l-0 border-r-0"></th>
            </tr>
          </thead>
          <tbody className="bg-white border-l-0 border-r-0 border-none">
            {filteredInvitations.map((inv) => (
              <tr key={inv.id} className="hover:bg-gray-50 transition-colors border-l-0 border-r-0 border-t-0 border-b border-gray-100">
                <td className="px-4 py-3 w-12 border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  <Checkbox
                    id={`inv-${inv.id}`}
                    checked={selectedInvitations.includes(inv.id)}
                    onChange={(checked) => handleInvitationSelect(checked, inv.id)}
                    size="sm"
                  />
                </td>
                <td className="px-4 py-3 text-[14px] font-medium text-[#18101C] truncate border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  {inv.email}
                </td>
                <td className="px-4 py-3 border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-md capitalize">
                    {inv.role}
                  </span>
                </td>
                <td className="px-4 py-3 text-[14px] text-gray-700 whitespace-nowrap border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  {inv.invitationSent}
                </td>
                <td className="px-4 py-3 text-right pr-6 border-b border-gray-100 border-l-0 border-r-0 border-t-0">
                  <div className="flex items-center gap-2 justify-end">
                    <button 
                      onClick={() => handleResendInvitation(inv.id)}
                      disabled={resendingIds.includes(inv.id) || resentIds.includes(inv.id)}
                      className={`flex items-center gap-1.5 px-4 py-1.5 rounded-md text-xs font-medium transition-colors ${
                        resentIds.includes(inv.id)
                          ? 'bg-[#C95EBE] text-white cursor-default'
                          : resendingIds.includes(inv.id)
                          ? 'bg-[#B14DAA] text-white cursor-not-allowed opacity-80'
                          : 'bg-[#C95EBE] text-white hover:bg-[#B14DAA]'
                      }`}
                    >
                      {getResendButtonContent(inv.id)}
                    </button>
                    <button 
                      onClick={() => handleCancelInvitation(inv.id)}
                      disabled={cancelingIds.includes(inv.id) || canceledIds.includes(inv.id)}
                      className={`px-4 py-1.5 border rounded-md text-xs font-medium transition-colors ${
                        canceledIds.includes(inv.id)
                          ? 'border-red-500 bg-red-500 text-white cursor-default'
                          : cancelingIds.includes(inv.id)
                          ? 'border-red-500 bg-red-500 text-white cursor-not-allowed opacity-80'
                          : 'border-red-500 text-red-500 hover:bg-red-500 hover:text-white'
                      }`}
                    >
                      {getCancelButtonContent(inv.id)}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default InvitationsPage;